// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2RulesAssignMemberNumberResultModel {
    static getAttributeTypeMap() {
        return EnrollmentV2RulesAssignMemberNumberResultModel.attributeTypeMap;
    }
}
EnrollmentV2RulesAssignMemberNumberResultModel.discriminator = undefined;
EnrollmentV2RulesAssignMemberNumberResultModel.attributeTypeMap = [
    {
        "name": "cardSourceId",
        "baseName": "cardSourceId",
        "type": "number"
    },
    {
        "name": "existingMemberNumber",
        "baseName": "existingMemberNumber",
        "type": "string"
    },
    {
        "name": "memberNumberType",
        "baseName": "memberNumberType",
        "type": "EnrollmentType"
    },
    {
        "name": "orderPdc",
        "baseName": "orderPdc",
        "type": "boolean"
    },
    {
        "name": "orderVdc",
        "baseName": "orderVdc",
        "type": "boolean"
    },
    {
        "name": "paymentMethodId",
        "baseName": "paymentMethodId",
        "type": "number"
    },
    {
        "name": "tcProgramId",
        "baseName": "tcProgramId",
        "type": "number"
    },
    {
        "name": "statusCode",
        "baseName": "statusCode",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentV2RulesAssignMemberNumberResultModel.js.map